import React, { memo } from 'react'
import { useThemeToggle, ThemeToggleProps } from './useThemeToggle'
import styles from './ThemeToggle.module.scss'
import MoonIcon from 'icons/moon.svg'
import SunIcon from 'icons/sun.svg'

const ThemeToggle: React.FC<ThemeToggleProps> = (props: ThemeToggleProps) => {
  const { theme, toggleTheme } = useThemeToggle(props)

  return (
    <label
      htmlFor='theme-toggle-switch'
      className={`${styles['theme-toggle']} ${theme === 'dark' ? styles['is-dark'] : ''}`}
    >
      <input
        type='checkbox'
        id='theme-toggle-switch'
        className={styles['toggle-input']}
        checked={theme === 'dark'}
        onChange={toggleTheme}
      />
      <div className={`${styles['toggle-icon']} ${styles.moon}`}>
        <img src={MoonIcon} width={32} height={32} alt='moon' />
      </div>
      <div className={`${styles['toggle-icon']} ${styles.sun}`}>
        <img src={SunIcon} width={32} height={32} alt='sun' />
      </div>
    </label>
  )
}

export default memo(ThemeToggle)
